
<template>

  <div class="trunc-outer" :style="{'left': skewLeft(), 'top': skewTop}">

  </div>

</template>

<script>

export default {

  data(){
    return {
      left: '',
      top: ''
    }
  },

  methods: {

    getCoords(e){
      const x = e.pageX;
      const y = e.pageY;
    }

  },

  mounted(){
    this.getCoords();
  }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/util/Truncator.vue